/* eslint-disable @typescript-eslint/no-explicit-any */
import lodash from "lodash";
import { PaxFinalProp, RoomFinalProp } from "./interface";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { RefObject, useEffect, useState } from "react";
import * as CryptoJS from "crypto-js";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
//import { customNotify } from "../../components/UI/ToastNotify";
import DOMPurify from "dompurify";
import { UIMessage } from "../../components/UI/UIMessage";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const emailRegex =
  /^(?!.*\.\.)(?!.*\.-)(?!.*-\.)[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

export function _exists(obj: any, keyPath: any) {
  return lodash.get(obj, keyPath);
}

export const encryptAPIData = (strText: string): string => {
  const strEncrKey = process.env.UI_SECRET_API_ENCRYPTION_KEY;

  // Check if the encryption key is defined
  if (!strEncrKey) {
    return ""; // or throw an error
  }

  // Use the first 8 characters of the key for DES
  const key = CryptoJS.enc.Utf8.parse(strEncrKey.substring(0, 8));
  const iv = CryptoJS.enc.Hex.parse("1234567890abcdef"); // Example IV

  try {
    const encrypted = CryptoJS.DES.encrypt(strText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedBase64 = encrypted.toString(); // Returns the encrypted text as a string
    // return encryptedBase64?.replace(/\+/g, "-")?.replace(/=+$/, ""); // check padding
    return encryptedBase64?.replace(/\+/g, "-");
  } catch (error) {
    console.error("Encryption error:", error);
    return "";
  }
};

export const decryptAPIData = (encryptedText: string): string => {
  const strEncrKey = process.env.UI_SECRET_API_ENCRYPTION_KEY;

  // Check if the encryption key is defined
  if (!strEncrKey) {
    return ""; // or throw an error
  }

  // Use the first 8 characters of the key for DES
  const key = CryptoJS.enc.Utf8.parse(strEncrKey.substring(0, 8));
  const iv = CryptoJS.enc.Hex.parse("1234567890abcdef"); // Example IV

  // // Always ensure proper base64 padding
  // function padBase64(str: string): string {
  //   const pad = str.length % 4;
  //   return pad ? str + "=".repeat(4 - pad) : str;
  // }

  try {
    // Convert from URL-safe base64 back to standard
    const updatedText = encryptedText.replace(/-/g, "+");
    // const padded = padBase64(updatedText);

    const decrypted = CryptoJS.DES.decrypt(updatedText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8); // Returns the decrypted text as a string
  } catch (error) {
    console.error("Decryption error:", error);
    return "";
  }
};

export const generateMailQuotationRandomCode = (): string => {
  // Define the prefix
  const prefix = "QTS";

  // Generate a random 5-digit number (adjusted based on your needs)
  const randomSuffix = Math.floor(Math.random() * 100000)
    .toString()
    .padStart(5, "0");

  // Combine the prefix and random suffix
  const code = `${prefix}${randomSuffix}`;

  return code;
};

export const getSelectedRoomsText = (
  selectedRooms: RoomFinalProp[],
  type: number | string,
  t: any,
  langType: any,
) => {
  if (selectedRooms?.length > 0) {
    let adultsCount = selectedRooms.reduce(
      (total, room) => total + (room?.adults || 0),
      0,
    );
    let childrenCount = selectedRooms.reduce(
      (total, room) => total + (room?.children_ages?.length || 0),
      0,
    );

    if (!adultsCount || adultsCount == undefined) {
      adultsCount = 0;
    }

    if (!childrenCount) {
      childrenCount = 0;
    }
    let returnRoomData = "";
    let finalData = "";

    if (type === 1) {
      const roomsCount = selectedRooms?.length;
      const roomsText = `${roomsCount} ${t(
        roomsCount > 1
          ? langType?.tab_content?.pax?.rooms
          : langType?.tab_content?.pax?.room,
      )}`;
      const adultText = ` - ${adultsCount} ${t(
        adultsCount > 1
          ? langType?.tab_content?.pax?.adults
          : langType?.tab_content?.pax?.adult,
      )}`;
      const childrenText = `, ${childrenCount} ${t(
        childrenCount > 1
          ? langType?.tab_content?.pax?.children
          : langType?.tab_content?.pax?.child,
      )}`;
      finalData = roomsText + adultText + (childrenCount ? childrenText : "");
      return finalData;
    } else if (type === 2) {
      returnRoomData = `${selectedRooms?.length +
        (selectedRooms?.length > 1
          ? ` ${t(langType?.tab_content?.pax?.rooms)}, `
          : ` ${t(langType?.tab_content?.pax?.room)}, `)
        } ${Number(adultsCount || 0) +
        (Number(adultsCount || 0) > 1
          ? ` ${t(langType?.tab_content?.pax?.adults)}`
          : ` ${t(langType?.tab_content?.pax?.adult)}`)
        } ${Number(childrenCount || 0) >= 1 ? "," : ""} 
      ${Number(childrenCount || 0) >= 1
          ? Number(childrenCount || 0) +
          (Number(childrenCount || 0) > 1
            ? ` ${t(langType?.tab_content?.pax?.children)}`
            : ` ${t(langType?.tab_content?.pax?.child)}`)
          : ""
        }
      `;
      finalData = returnRoomData.replace("    ", "");
      return finalData;
    } else if (type === 124) {
      // means for transfers
      returnRoomData = `${Number(adultsCount || 0) +
        (Number(adultsCount || 0) > 1
          ? ` ${t(langType?.tab_content?.pax?.adults)}`
          : ` ${t(langType?.tab_content?.pax?.adult)}`)
        }${Number(childrenCount || 0) >= 1 ? "," : ""} 
      ${Number(childrenCount || 0) >= 1
          ? Number(childrenCount || 0) +
          (Number(childrenCount || 0) > 1
            ? ` ${t(langType?.tab_content?.pax?.children)}`
            : ` ${t(langType?.tab_content?.pax?.child)}`)
          : ""
        }
      `;
      finalData = returnRoomData.replace("    ", "");
      return finalData;
    } else if (type === "activityCount") {
      // means for Activities
      returnRoomData = `${Number(adultsCount || 0) +
        (Number(adultsCount || 0) > 1
          ? ` ${t(langType?.tab_content?.pax?.adults)}`
          : ` ${t(langType?.tab_content?.pax?.adult)}`)
        }${Number(childrenCount || 0) >= 1 ? "," : ""} 
      ${Number(childrenCount || 0) >= 1
          ? Number(childrenCount || 0) +
          (Number(childrenCount || 0) > 1
            ? ` ${t(langType?.tab_content?.pax?.children)}`
            : ` ${t(langType?.tab_content?.pax?.child)}`)
          : ""
        }
      `;
      finalData = returnRoomData.replace("    ", "");
      return finalData;
    } else if (type === "transfersCount") {
      // means for Transfers
      returnRoomData = `${Number(adultsCount || 0) +
        (Number(adultsCount || 0) > 1
          ? ` ${t(langType?.tab_content?.pax?.adults)}`
          : ` ${t(langType?.tab_content?.pax?.adult)}`)
        }${Number(childrenCount || 0) >= 1 ? "," : ""} 
      ${Number(childrenCount || 0) >= 1
          ? Number(childrenCount || 0) +
          (Number(childrenCount || 0) > 1
            ? ` ${t(langType?.tab_content?.pax?.children)}`
            : ` ${t(langType?.tab_content?.pax?.child)}`)
          : ""
        }
      `;
      finalData = returnRoomData.replace("    ", "");
      return finalData;
    } else if (type === "adultCount") {
      // means get only adult count
      return Number(adultsCount || 0);
    } else {
      returnRoomData = `${selectedRooms?.length +
        (selectedRooms?.length > 1
          ? ` ${t(langType?.tab_content?.pax?.rooms)}, `
          : ` ${t(langType?.tab_content?.pax?.room)},`)
        } ${Number(adultsCount || 0) +
        (Number(adultsCount || 0) > 1
          ? ` ${t(langType?.tab_content?.pax?.adults)}`
          : ` ${t(langType?.tab_content?.pax?.adult)}`)
        }${Number(childrenCount || 0) >= 1 ? "," : ""} 
      ${Number(childrenCount || 0) >= 1
          ? Number(childrenCount || 0) +
          (Number(childrenCount || 0) > 1
            ? ` ${t(langType?.tab_content?.pax?.children)}`
            : ` ${t(langType?.tab_content?.pax?.child)}`)
          : ""
        }
      `;

      finalData = returnRoomData.replace("    ", "");
      return finalData;
    }
  } else {
    return "";
  }
};

export const getSelectedPaxText = (
  selectedPax: PaxFinalProp,
  t: any,
  langType: any,
  type?: any,
) => {
  if (Object?.keys(selectedPax)?.length > 0) {
    return (
      Object?.entries(selectedPax)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ?.filter(([_, value]) => value !== null && value !== undefined) // Remove entries with null or undefined values
        ?.map(([key, value]) => {
          let word;
          if (key === "childs") {
            word =
              value < 2
                ? t(langType?.tab_content?.pax?.child)
                : t(langType?.tab_content?.pax?.children);
          } else if (key === "infants") {
            word =
              value < 2
                ? t(langType?.tab_content?.pax?.infant)
                : t(langType?.tab_content?.pax?.infants);
          } else if (key === "seniors") {
            word =
              value < 2
                ? t(langType?.tab_content?.pax?.senior)
                : t(langType?.tab_content?.pax?.seniors);
          } else if (key === "youths") {
            word =
              value < 2
                ? t(langType?.tab_content?.pax?.youth)
                : t(langType?.tab_content?.pax?.youths);
          } else {
            word =
              value < 2
                ? t(langType?.tab_content?.pax?.adult)
                : t(langType?.tab_content?.pax?.adults);
          }
          return type == "nozero"
            ? value != 0 && `${value} ${word}`
            : `${value} ${word}`;
        })
        ?.filter(Boolean)
        ?.join(", ")
    );
  } else {
    return "";
  }
};

export const getEurailPaxText = (
  selectedPax: any,
  type?: string,
  langType?: any,
) => {
  if (selectedPax && Object?.keys(selectedPax)?.length > 0) {
    let paxText = "";
    const adultCount = Number(selectedPax?.adults) || 0;
    const childrenCount = Number(selectedPax?.children_ages?.length) || 0;
    const seniorCount = Number(selectedPax?.seniors) || 0;

    if (adultCount > 0) {
      paxText = `${adultCount} ${
        adultCount > 1
          ? langType?.Adults || "Adults"
          : langType?.Adult || "Adult"
      }`;
    }
    if (childrenCount > 0) {
      paxText +=
        (paxText ? (type === "pass" ? " | " : ", ") : "") +
        `${childrenCount} ${
          childrenCount > 1
            ? langType?.Children || "Children"
            : langType?.Child || "Child"
        }`;
    }

    if (seniorCount > 0) {
      paxText +=
        (paxText ? (type === "pass" ? " | " : ", ") : "") +
        `${seniorCount} ${
          seniorCount > 1
            ? langType?.Seniors || "Seniors"
            : langType?.Senior || "Senior"
        }`;
    }

    // paxText = `${adultCount + (adultCount > 1 ? " Adults, " : " Adult, ")}${
    //   childrenCount + (childrenCount > 1 ? " Children, " : " Child, ")
    // }${seniorCount + (seniorCount > 1 ? " Seniors" : " Senior")}`

    return paxText;
  } else {
    return "";
  }
};

export const getSelectedAdultChildText = (
  selectedAdultChild: RoomFinalProp,
  type: string,
) => {
  if (Object.entries(selectedAdultChild).length > 0) {
    const adultsCount = selectedAdultChild?.adults;
    const childrenCount = selectedAdultChild?.children_ages?.length;
    return `${adultsCount} adults ${childrenCount} childrens`;
  } else {
    return type === "PAX" ? "Select PAX" : "Select Guests";
  }
};

export const encrypt = async (plainText: string, password: string) => {
  const encoder = new TextEncoder();
  const passwordBuffer = encoder.encode(password);
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    passwordBuffer,
    { name: "PBKDF2" },
    false,
    ["deriveKey"],
  );
  const key = await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt,
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"],
  );
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoder.encode(plainText),
  );
  const encryptedString = Array.from(new Uint8Array(encrypted))
    .map((b) => String.fromCharCode(b))
    .join("");
  return `${salt.join("")}:${iv.join("")}:${encryptedString}`;
};

export const decrypt = async (encryptedText: string, password: string) => {
  const [saltStr, ivStr, encryptedStr] = encryptedText.split(":");
  const salt = new Uint8Array(saltStr.split("").map((c) => c.charCodeAt(0)));
  const iv = new Uint8Array(ivStr.split("").map((c) => c.charCodeAt(0)));
  const encoder = new TextEncoder();
  const passwordBuffer = encoder.encode(password);
  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    passwordBuffer,
    { name: "PBKDF2" },
    false,
    ["deriveKey"],
  );
  const key = await crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt,
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"],
  );
  const encryptedBytes = new Uint8Array(
    encryptedStr.split("").map((c) => c.charCodeAt(0)),
  );
  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    encryptedBytes,
  );
  const decoder = new TextDecoder();
  return decoder.decode(decrypted);
};

// groupRoomsSeparately function starts here.............
interface Room {
  room_type: string;
}

interface Rate {
  rooms: Room[];
}

export const groupRoomsSeparately = (rates: Rate[]): { rates: Rate[] } => {
  const groupedRates: Rate[] = [];

  // Create a map to collect rooms by type
  const roomTypeMap: { [key: string]: Rate[] } = {};

  // Group rooms by type
  rates.forEach((rate) => {
    rate.rooms.forEach((room) => {
      const type = room.room_type;
      if (!roomTypeMap[type]) {
        roomTypeMap[type] = [];
      }
      roomTypeMap[type].push(rate);
    });
  });

  // Convert the map back to a rates array with separate room arrays
  for (const type in roomTypeMap) {
    roomTypeMap[type].forEach((room) => {
      groupedRates.push(room);
    });
  }

  return { rates: groupedRates };
};
// groupRoomsSeparately function ends here................

// to get the output like [0, 5, 10, 15, 20]
export const getBetweenValues = ({
  minPrice,
  maxPrice,
  numValues,
}: {
  minPrice: number;
  maxPrice: number;
  numValues: number;
}) => {
  const step = (maxPrice - minPrice) / (numValues + 1);
  const values = [];

  for (let i = 1; i <= numValues; i++) {
    values.push(minPrice + i * step);
  }

  return values;
};

export function formatOrdinalDate(
  dateString: string | number | Date | dayjs.Dayjs | null | undefined,
) {
  const day = dayjs(dateString, "DD/MM/YYYY").format("D");
  const suffix = getOrdinalSuffix(day);
  return `${day}${suffix} ${dayjs(dateString, "DD/MM/YYYY").format(
    "MMM YYYY",
  )}`;
}

export function formatOrdinalDateWithYear(
  dateString: string | number | Date | dayjs.Dayjs | null | undefined,
) {
  const day = dayjs(dateString, "DD/MM/YYYY").format("D");
  const suffix = getOrdinalSuffix(day);
  return `${day}${suffix} ${dayjs(dateString, "DD/MM/YYYY").format(
    "MMM YY",
  )}`;
}

export function getOrdinalSuffix(day: string) {
  if (day === "1" || day === "21" || day === "31") return "st";
  if (day === "2" || day === "22") return "nd";
  if (day === "3" || day === "23") return "rd";
  return "th";
}

export const priceShorterConverter = (number: number) => {
  const formatter = Intl.NumberFormat("en", { notation: "compact" });
  return formatter.format(number);
};
// export const priceShorterConverterWithMath = (price: number) => {
//   if (price >= 1000 && price < 1000000) {
//     return `${Math.floor(price / 1000)}K`;
//   }
//   if (price >= 1000000) {
//     return `${Math.floor(price / 1000000)}M`;
//   }
//   return price;
// };
export const priceShorterConverterWithMath = (price: number) => {
  const truncate = (num: number, decimals: number) => {
    const factor = Math.pow(10, decimals);
    return Math.floor(num * factor) / factor;
  };

  if (price >= 1000 && price < 1000000) {
    const value = truncate(price / 1000, 1);
    return `${value}K`;
  }
  if (price >= 1000000) {
    const value = truncate(price / 1000000, 1);
    return `${value}M`;
  }
  return price.toString();
};

export const getTextFieldWidth = (text: string) => {
  // Create a canvas to measure text width
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (context) {
    // Set a default font style (customize as needed)
    context.font = "400 16px Arial";
    const textWidth = context.measureText(text || "").width;
    return Math.max(240, textWidth);
  }
  return 240;
};

// gives html template with applied css from browser (used for sending mail)
export const captureElementWithAppliedCSS = (elementId: string) => {
  const targetElement = document.getElementById(elementId);

  if (!targetElement) {
    return null;
  }

  // Clone the target element
  const clone = targetElement.cloneNode(true) as any;

  const getAppliedStyles = (element: Element) => {
    const styles = window.getComputedStyle(element);
    let cssText = "";
    for (let i = 0; i < styles.length; i++) {
      const prop = styles[i];
      const value = styles.getPropertyValue(prop);
      if (value !== "") {
        cssText += `${prop}:${value};`;
      }
    }
    return cssText;
  };

  const applyStylesToElement = (
    originalElement: Element,
    clonedElement: any,
  ) => {
    const appliedStyles = getAppliedStyles(originalElement);
    clonedElement.style.cssText = appliedStyles;

    // Handle pseudo-elements
    const pseudoElements = [":before", ":after"];
    pseudoElements.forEach((pseudo) => {
      const pseudoStyles = window.getComputedStyle(originalElement, pseudo);
      const pseudoContent = pseudoStyles.getPropertyValue("content");
      if (pseudoContent !== "none") {
        const pseudoDiv = document.createElement("div");
        pseudoDiv.style.cssText = getAppliedStyles(originalElement);
        pseudoDiv.textContent = pseudoContent.replace(/['"]/g, "");
        pseudoDiv.style.display = "inline";
        clonedElement.insertBefore(pseudoDiv, clonedElement.firstChild);
      }
    });

    // Apply styles to children recursively
    for (let i = 0; i < originalElement.children.length; i++) {
      applyStylesToElement(
        originalElement.children[i],
        clonedElement.children[i],
      );
    }
  };

  applyStylesToElement(targetElement, clone);

  // Get the final HTML with applied CSS
  const htmlWithAppliedCSS = clone.outerHTML;

  return htmlWithAppliedCSS;
};

export const insertHTMLContent = (
  templateString: string,
  contentToInsert: any,
  placeholder: string,
) => {
  return templateString.replace(placeholder, contentToInsert);
};

export const handlePDF = async (
  contentRef: RefObject<HTMLDivElement>,
  //width?: number,
  //height?: number,
  type?: string,
  isPortrait?: boolean,
  setIsLoading?: any,
  page?: any,
) => {
  if (!contentRef.current) return;
  setIsLoading?.(true);
  try {
    // Capture the content as a high-resolution canvas
    if (["Invoice"].indexOf(page) !== -1) {
      const orientation = isPortrait ? "portrait" : "portrait";
      const pdf = new jsPDF(orientation, "mm", "a4");

      const marginLeft = 10;
      const marginTop = 10;
      const marginRight = 10;
      const marginBottom = 10;

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const usableWidth = pageWidth - marginLeft - marginRight + 30;
      const usableHeight = pageHeight - marginTop - marginBottom;
      if (["Invoice", "Proforma", "CreditNote", "DebitNote"].includes(page)) {
      }

      const canvas = await html2canvas(contentRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);

      // Calculate scale to fit entire content on one page
      const contentRatio = imgProps.width / imgProps.height;
      const pageRatio = usableWidth / usableHeight;

      let imgWidth = usableWidth;
      let imgHeight = usableHeight;

      if (contentRatio > pageRatio) {
        imgHeight = imgWidth / contentRatio;
      } else {
        imgWidth = imgHeight * contentRatio;
      }

      pdf.addImage(imgData, "PNG", marginLeft, marginTop, imgWidth, imgHeight);

      const pdfURL = pdf.output("bloburl");
      window.open(pdfURL, "_blank");
    } else if (["voucher"].indexOf(page) !== -1) {
      const orientation = !isPortrait ? "landscape" : "portrait";
      const pdf = new jsPDF(orientation, "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const usableWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2;
      pdf.rect(margin / 2, margin / 2, pageWidth - margin, pageHeight - margin);

      const sections = [
        "header_section",
        "price_section",
        "notes_section",
        "payment_status_section",
      ];

      let currentY = margin; //current vertical position on the PDF

      for (const section of sections) {
        const element = contentRef.current.querySelector(
          `.${section}`,
        ) as HTMLElement;
        if (!element) continue;

        // ✅ 1. Render this section only
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff",
        });

        const imgWidth = usableWidth;
        // Convert pageHeight to pixel scale (same ratio as canvas)
        const pageHeightPx = (usableHeight * canvas.width) / usableWidth;

        let remainingHeight = canvas.height;
        let positionPx = 0;

        while (remainingHeight > 0) {
          // Create a temporary cropped canvas for this page slice
          const pageCanvas = document.createElement("canvas");
          pageCanvas.width = canvas.width;
          pageCanvas.height = Math.min(pageHeightPx, remainingHeight);

          const ctx = pageCanvas.getContext("2d");
          if (!ctx) break;

          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
          ctx.drawImage(
            canvas,
            0,
            positionPx,
            canvas.width,
            pageCanvas.height,
            0,
            0,
            canvas.width,
            pageCanvas.height,
          );

          const imgData = pageCanvas.toDataURL("image/png", 0.8);
          const sliceHeight =
            (pageCanvas.height * usableWidth) / pageCanvas.width;

          // If this slice won’t fit, add new page
          if (currentY + sliceHeight > pageHeight - margin) {
            pdf.addPage();
            currentY = margin;
          }

          // Add image slice to PDF
          pdf.addImage(
            imgData,
            "PNG",
            margin,
            currentY,
            imgWidth,
            sliceHeight,
            undefined,
            "FAST",
          );

          // Update counters
          currentY += sliceHeight;
          remainingHeight -= pageHeightPx;
          positionPx += pageHeightPx;

          // If still more left — move to next PDF page cleanly
          if (remainingHeight > 0) {
            pdf.addPage();
            currentY = margin;
          }
        }

        // Add a bit of space before the next section
        currentY += 5;
      }

      // Optional: draw borders on each page
      pdf.setDrawColor(150, 150, 150);
      pdf.setLineWidth(0.05);
      const totalPages = pdf.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.rect(5, 5, pageWidth - 10, pageHeight - 10);
      }
      const pdfURL = pdf.output("bloburl");
      window.open(pdfURL, "_blank");
    } else {
      // if (["Proforma", "BookingConfirmation"].indexOf(page) !== -1) {
      //   const orientation = !isPortrait ? "landscape" : "portrait";
      //   const pdf = new jsPDF(orientation, "mm", "a4");
      //   const pageWidth = pdf.internal.pageSize.getWidth();
      //   const pageHeight = pdf.internal.pageSize.getHeight();
      //   const margin = 10;
      //   const usableWidth = pageWidth - margin * 2;

      //   // Sections to capture
      //   const sections = [
      //     "header_section",
      //     "price_section",
      //     "notes_section",
      //     "payment_status_section",
      //   ];
      //   let isFirst = true;
      //   for (const section of sections) {
      //     const element = contentRef.current.querySelector(
      //       `.${section}`,
      //     ) as HTMLElement;
      //     if (!element) continue;
      //     // Render section into canvas
      //     const canvas = await html2canvas(element, {
      //       scale: 2,
      //       useCORS: true,
      //     });
      //     const imgData = canvas.toDataURL("image/png"); // Scale image
      //     const imgWidth = usableWidth;
      //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

      //     if (!isFirst) pdf.addPage();
      //     // Add border (x, y, width, height)
      //     pdf.rect(
      //       margin / 2,
      //       margin / 2,
      //       pageWidth - margin,
      //       pageHeight - margin,
      //     );

      //     pdf.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
      //     // Draw border
      //     pdf.setDrawColor(150, 150, 150); // black
      //     pdf.setLineWidth(0.05);
      //     pdf.rect(5, 5, pageWidth - 10, pageHeight - 10); // border inside page

      //     isFirst = false;
      //   }
      //   // Add page numbers at bottom-right
      //   const totalPages = pdf.getNumberOfPages();
      //   for (let i = 1; i <= totalPages; i++) {
      //     pdf.setPage(i);
      //     pdf.setFontSize(10);
      //     pdf.text(`${i}/${totalPages}`, pageWidth - 15, pageHeight - 10, {
      //       align: "right",
      //     });
      //   }
      //   // Generate the Blob URL and open it in a new tab
      //   const pdfURL = pdf.output("bloburl");
      //   const a = window.open(pdfURL, "_blank");
      //   return a;
      // }
      if (page === "BookingConfirmation") {
        const element = contentRef.current;

        if (!element) {
          setIsLoading?.(false);
          return;
        }

        const orientation = !isPortrait ? "landscape" : "portrait";
        const pdf = new jsPDF(orientation, "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const margin = 10;
        const usableWidth = pageWidth - margin * 2;
        const usableHeight = pageHeight - margin * 2;

        // Keep the popup open by opening it immediately from the click event
        const printWindow = window.open("", "_blank");

        if (!printWindow) {
          console.error("Popup blocked by browser");
          setIsLoading?.(false);
          return;
        }

        // Store original styles so we can restore them after PDF generation
        const originalStyle = {
          width: element.style.width,
          minWidth: element.style.minWidth,
          maxWidth: element.style.maxWidth,
          overflow: element.style.overflow,
        };

        // Desktop width used only while generating the PDF
        const PDF_CAPTURE_WIDTH = 1200;

        try {
          // ---------------------------------------------------------
          // FORCE DESKTOP LAYOUT
          // ---------------------------------------------------------
          element.style.width = `${PDF_CAPTURE_WIDTH}px`;
          element.style.minWidth = `${PDF_CAPTURE_WIDTH}px`;
          element.style.maxWidth = `${PDF_CAPTURE_WIDTH}px`;
          element.style.overflow = "visible";

          // Force browser to recalculate the layout
          await new Promise<void>((resolve) => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                resolve();
              });
            });
          });

          // ---------------------------------------------------------
          // CAPTURE BOOKING CONFIRMATION
          // ---------------------------------------------------------
          const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
            logging: false,

            // Important: render as desktop
            width: PDF_CAPTURE_WIDTH,
            windowWidth: PDF_CAPTURE_WIDTH,

            // Capture the complete element
            height: element.scrollHeight,
            windowHeight: Math.max(
              element.scrollHeight,
              window.innerHeight
            ),
          });

          // ---------------------------------------------------------
          // CALCULATE PDF IMAGE SIZE
          // ---------------------------------------------------------
          const imgWidth = usableWidth;

          const pxPerMm = canvas.width / imgWidth;

          const pageHeightPx = usableHeight * pxPerMm;

          let position = 0;
          let pageNumber = 0;

          // ---------------------------------------------------------
          // SPLIT CANVAS INTO A4 PAGES
          // ---------------------------------------------------------
          while (position < canvas.height) {
            const remainingHeight = canvas.height - position;

            const sliceHeightPx = Math.min(
              pageHeightPx,
              remainingHeight
            );

            // Create canvas for current PDF page
            const pageCanvas = document.createElement("canvas");

            pageCanvas.width = canvas.width;
            pageCanvas.height = Math.ceil(sliceHeightPx);

            const ctx = pageCanvas.getContext("2d");

            if (!ctx) {
              throw new Error(
                "Unable to create canvas context"
              );
            }

            // White background
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(
              0,
              0,
              pageCanvas.width,
              pageCanvas.height
            );

            // Draw current section of original canvas
            ctx.drawImage(
              canvas,
              0,
              position,
              canvas.width,
              sliceHeightPx,
              0,
              0,
              canvas.width,
              sliceHeightPx
            );

            const pageImgData =
              pageCanvas.toDataURL("image/png");

            const sliceHeightMm =
              pageCanvas.height / pxPerMm;

            // Add a new page after the first page
            if (pageNumber > 0) {
              pdf.addPage();
            }

            // -------------------------------------------------------
            // ADD IMAGE
            // -------------------------------------------------------
            pdf.addImage(
              pageImgData,
              "PNG",
              margin,
              margin,
              imgWidth,
              sliceHeightMm,
              undefined,
              "FAST"
            );

            // -------------------------------------------------------
            // ADD BORDER
            // -------------------------------------------------------
            pdf.setDrawColor(150, 150, 150);
            pdf.setLineWidth(0.05);

            pdf.rect(
              5,
              5,
              pageWidth - 10,
              pageHeight - 10
            );

            position += sliceHeightPx;
            pageNumber++;
          }

          // ---------------------------------------------------------
          // ADD PAGE NUMBERS
          // ---------------------------------------------------------
          const totalPages = pdf.getNumberOfPages();

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);

            pdf.setFontSize(10);

            pdf.text(
              `${i}/${totalPages}`,
              pageWidth - 15,
              pageHeight - 10,
              {
                align: "right",
              }
            );
          }

          // ---------------------------------------------------------
          // OPEN PDF
          // ---------------------------------------------------------
          const pdfBlob = pdf.output("blob");

          const pdfURL = URL.createObjectURL(pdfBlob);

          printWindow.location.href = pdfURL;

          // Cleanup URL after browser has loaded it
          setTimeout(() => {
            URL.revokeObjectURL(pdfURL);
          }, 10000);

        } catch (error) {
          console.error(
            "Error generating Booking Confirmation PDF:",
            error
          );

          printWindow.close();

        } finally {
          // ---------------------------------------------------------
          // RESTORE ORIGINAL STYLES
          // ---------------------------------------------------------
          element.style.width = originalStyle.width;
          element.style.minWidth = originalStyle.minWidth;
          element.style.maxWidth = originalStyle.maxWidth;
          element.style.overflow = originalStyle.overflow;

          setIsLoading?.(false);
        }

        return;
      } else if (page === "Proforma") {
        // KEEP YOUR EXISTING PROFORMA CODE HERE
      }

      else {
        const canvas = await html2canvas(contentRef.current, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");

        const padding = type == "voucher" ? 10 : 1;
        const paddingLeft = type === "voucher" ? 10 : 0;
        const paddingRight = type === "voucher" ? 5 : 0;
        const orientation = !isPortrait ? "landscape" : "portrait";
        const pdf = new jsPDF(orientation, "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Calculate image dimensions in mm
        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = pageWidth - paddingRight - paddingLeft;
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

        let position = padding;

        // Only add image **once**
        pdf.addImage(imgData, "PNG", 8, position, imgWidth, imgHeight);
        position -= pageHeight;
        while (Math.abs(position) < imgHeight) {
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 8, position, imgWidth, imgHeight);
          position -= pageHeight;
        }

        // Generate the Blob URL and open it in a new tab
        const pdfURL = pdf.output("bloburl");
        window.open(pdfURL, "_blank");
      }
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
  setIsLoading?.(false);
};
export const handlePrint = (contentRef: RefObject<HTMLDivElement>) => {
  if (!contentRef.current) return;

  // 1. Clone the content so the original DOM is untouched
  const printContent = contentRef.current.cloneNode(true) as HTMLElement;
  // 2. Optionally remove any buttons inside the content
  printContent
    .querySelectorAll(".voucher-download-btn")
    .forEach((el) => el.remove());

  // 3. Create a hidden print container
  const printContainer = document.createElement("div");
  printContainer.style.position = "fixed";
  printContainer.style.left = "-9999px"; // hide offscreen
  printContainer.appendChild(printContent);
  document.body.appendChild(printContainer);

  // 4. Print
  // window.print();

  // 5. Cleanup
  document.body.removeChild(printContainer);
};
export async function domToBase64(
  element: HTMLElement | null,
  options?: {
    format?: "png" | "jpeg";
    quality?: number; // for jpeg only
    scale?: number; // higher DPI
  },
): Promise<string | null> {
  if (!element) return null;

  const { format = "png", quality = 0.95, scale = 2 } = options || {};

  const canvas = await html2canvas(element, {
    useCORS: true,
    scale,
  });

  return format === "jpeg"
    ? canvas.toDataURL("image/jpeg", quality)
    : canvas.toDataURL("image/png");
}
export const QuoteMailTemplate = (): string => {
  return `<div>QuoteMailTemplate</div>`;
};

// it will give the currency of agent for admin
export const getAgentPreferredCurrencyForAdmin = ({
  agentid,
  selectedAgents,
}: {
  agentid: string;
  selectedAgents:
  | {
    preferred_currency: string;
    id: string;
  }[]
  | null;
}) => {
  if (selectedAgents && selectedAgents?.length > 0) {
    const findAgentById = selectedAgents?.find(function (e: { id: string }) {
      return e?.id?.toString() == agentid;
    });
    if (findAgentById?.preferred_currency) {
      return findAgentById?.preferred_currency;
    }
    return null;
  }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const getUserIPAddress = async (): Promise<string | null> => {
  const ip = await new Promise<string | null>((resolve) => {
    const value = localStorage.getItem("ipaddress");
    resolve(value);
  });

  return ip ? DOMPurify.sanitize(ip) : null;
};

export const convertFileToBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const getSelectedDestinationName = (
  destinationValue: string,
  apiData: any,
) => {
  let destinationName = "";

  if (destinationValue) {
    const locationSelectedItem =
      Array.isArray(apiData) &&
      apiData.find((item: { value: string; location: string }) => {
        return item?.value === destinationValue;
      });

    // Validate locationSelectedItem before using it
    if (locationSelectedItem && locationSelectedItem?.name) {
      destinationName = locationSelectedItem?.name;
    }
  }

  return destinationName;
};

export const whatToWhatSelectedInTransfer = (
  pickupfrom: string | null,
  dropoffto: string | null,
) => {
  if (pickupfrom || dropoffto) {
    if (!pickupfrom) {
      if (dropoffto) {
        if (dropoffto == "A") {
          return "-A";
        }
        if (dropoffto == "H") {
          return "-H";
        }
      }
    }

    if (!dropoffto) {
      if (pickupfrom) {
        if (pickupfrom == "A") {
          return "A-";
        }
        if (pickupfrom == "H") {
          return "H-";
        }
      }
    }

    if (pickupfrom) {
      if (dropoffto) {
        if (dropoffto == "A" && pickupfrom == "A") {
          return "A-A";
        }
        if (dropoffto == "H" && pickupfrom == "H") {
          return "H-H";
        }
        if (dropoffto == "A" && pickupfrom == "H") {
          return "H-A";
        }
        if (dropoffto == "H" && pickupfrom == "A") {
          return "A-H";
        }
      }
    }
  }
};

export const isItUnderCancellation = (chargeFreeDateTime: any) => {
  if (chargeFreeDateTime) {
    const futureDate = dayjs(chargeFreeDateTime, "DD-MM-YYYY HH:mm:ss");

    if (futureDate.isAfter(dayjs())) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const isItNRF = (
  non_refundable: boolean,
  under_cancellation: boolean,
  cancel_by_date: any, // piyush said that chargeFreeDateTime(from prebook response) is cancel_by_date
) => {
  if (
    non_refundable === false &&
    under_cancellation == false &&
    cancel_by_date &&
    cancel_by_date != ""
  ) {
    // rk said that we dont need to check the that it is greater than today. because while cancelling they will check from backend
    // const futureDate = dayjs(cancel_by_date, "DD-MM-YYYY HH:mm:ss");
    // const isFutureDate = futureDate.isAfter(dayjs());
    // if (isFutureDate) {
    return false; // timelimit booking
    // } else {
    //   return true; // NRF booking
    // }
  } else {
    return true; // NRF booking
  }
};

export const isItPartiallyRefundable = (
  non_refundable: boolean,
  under_cancellation: boolean,
) => {
  if (non_refundable === false && under_cancellation === true) {
    return true;
  }
  return false;
};

export const isItNRF_ForCorrectDateFormat = (
  non_refundable: boolean,
  under_cancellation: boolean,
  cancel_by_date: any, // piyush said that chargeFreeDateTime(from prebook response) is cancel_by_date
) => {
  if (
    non_refundable === false &&
    under_cancellation == false &&
    cancel_by_date &&
    cancel_by_date != ""
  ) {
    // rk said that we dont need to check the that it is greater than today. because while cancelling they will check from backend
    const futureDate = dayjs(cancel_by_date, "DD-MM-YYYY HH:mm:ss");
    const isFutureDate = futureDate.isAfter(dayjs());

    if (isFutureDate) {
      return false; // timelimit booking
    } else {
      return true; // NRF booking
    }
  } else {
    return true; // NRF booking
  }
};

export const getHotelRefundPolicy = (
  non_refundable: boolean,
  under_cancellation: boolean,
  cancel_by_date: any,
) => {
  if (!non_refundable && under_cancellation) {
    return 2; // partially refundable
  } else if (
    isItNRF(non_refundable, under_cancellation, cancel_by_date) == true
  ) {
    return 1; // non refundable
  } else {
    return 0;
  }
};

// Maps real payment.card_required / payment.deposit_required to which
// requirement label(s) to show. Works for both the room-level (hotelRates)
// and hotel-level (hotelsList) payment object, which share the same shape.
export const getPaymentRequirementInfo = (
  payment?: {
    card_required?: boolean | null;
    deposit_required?: boolean | null;
  } | null,
): { typeLabelKey: "pay_at_property" | "pay_before_arrival"; cardRequired: boolean } => ({
  typeLabelKey: payment?.deposit_required === true ? "pay_before_arrival" : "pay_at_property",
  cardRequired: payment?.card_required === true,
});

export const getAllQuotesFromLocalStorage = () => {
  // --------------------> get quotes starts here
  const localStorageData = DOMPurify.sanitize(
    localStorage.getItem("persist:root") as string,
  );
  const decodedLocalStorageData =
    localStorageData && JSON.parse(localStorageData)?.localStorageReducer;
  const LocalQuoteRooms = decodedLocalStorageData
    ? JSON.parse(decodedLocalStorageData)?.LocalQuoteRooms
    : [];
  const LocalQuoteTransfers = decodedLocalStorageData
    ? JSON.parse(decodedLocalStorageData)?.LocalQuoteTransfers
    : [];
  const localQuoteActivities = decodedLocalStorageData
    ? JSON.parse(decodedLocalStorageData)?.localQuoteActivities
    : [];
  // --------------------> get quotes ends here

  return {
    LocalQuoteRooms,
    LocalQuoteTransfers,
    localQuoteActivities,
  };
};

export const getAllHotelLocalQuotes = () => {
  const storedValue = DOMPurify.sanitize(
    localStorage.getItem("hotelQuotes") as string,
  );
  const LocalQuoteRooms = storedValue ? JSON.parse(storedValue) : [];
  return LocalQuoteRooms;
};

export const getAllTransferLocalQuotes = () => {
  const storedValue = DOMPurify.sanitize(
    localStorage.getItem("transferQuotes") as string,
  );
  const LocalQuoteTransfers = storedValue ? JSON.parse(storedValue) : [];
  return LocalQuoteTransfers;
};

export const getAllActivityLocalQuotes = () => {
  const storedValue = DOMPurify.sanitize(
    localStorage.getItem("activityQuotes") as string,
  );
  const localQuoteActivities = storedValue ? JSON.parse(storedValue) : [];
  return localQuoteActivities;
};

export const getHotelCompareRooms = () => {
  const storedValue = DOMPurify.sanitize(
    localStorage.getItem("hotelCompare") as string,
  );
  const compareRooms = storedValue ? JSON.parse(storedValue) : [];
  return compareRooms;
};

export const getAllCompareRooms = () => {
  const rooms = DOMPurify.sanitize(
    localStorage.getItem("hotelCompare") as string,
  );
  return rooms ? JSON.parse(rooms) : []; // Parse the JSON string or return an empty array
};

export const clearAllLocalQuotes = () => {
  localStorage.setItem("hotelQuotes", JSON.stringify([]));
  localStorage.setItem("transferQuotes", JSON.stringify([]));
  localStorage.setItem("activityQuotes", JSON.stringify([]));
};

export const uiEncryption = (originalText: string) => {
  if (process.env.UI_ENCRYPTION_SECRET) {
    const encJson = CryptoJS.AES.encrypt(
      JSON.stringify(originalText),
      process.env.UI_ENCRYPTION_SECRET,
    ).toString();
    const encData = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(encJson),
    );
    return encData;
  }
};

export const uiDecryption = (ciphertext: string) => {
  if (process.env.UI_ENCRYPTION_SECRET && ciphertext) {
    const decData = CryptoJS.enc.Base64.parse(ciphertext).toString(
      CryptoJS.enc.Utf8,
    );
    const bytes = CryptoJS.AES.decrypt(
      decData,
      process.env.UI_ENCRYPTION_SECRET,
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(bytes);
  }
};

export function numberToWords(num: number, currency: string = "INR"): string {
  const unitsMap: Record<number, string> = {
    0: "zero",
    1: "one",
    2: "two",
    3: "three",
    4: "four",
    5: "five",
    6: "six",
    7: "seven",
    8: "eight",
    9: "nine",
    10: "ten",
    11: "eleven",
    12: "twelve",
    13: "thirteen",
    14: "fourteen",
    15: "fifteen",
    16: "sixteen",
    17: "seventeen",
    18: "eighteen",
    19: "nineteen",
  };

  const tensMap: Record<number, string> = {
    2: "twenty",
    3: "thirty",
    4: "forty",
    5: "fifty",
    6: "sixty",
    7: "seventy",
    8: "eighty",
    9: "ninety",
  };

  const convertIntegerPart = (num: number): string => {
    if (num === 0) {
      return "zero";
    }

    if (num < 20) {
      return unitsMap[num];
    }

    if (num < 100) {
      const tens = Math.floor(num / 10);
      const units = num % 10;
      return tensMap[tens] + (units > 0 ? "-" + unitsMap[units] : "");
    }

    if (num < 1000) {
      const hundreds = Math.floor(num / 100);
      const rest = num % 100;
      return (
        unitsMap[hundreds] +
        " hundred" +
        (rest > 0 ? " and " + convertIntegerPart(rest) : "")
      );
    }

    if (num < 100000) {
      const thousands = Math.floor(num / 1000);
      const rest = num % 1000;
      return (
        convertIntegerPart(thousands) +
        " thousand" +
        (rest > 0 ? " " + convertIntegerPart(rest) : "")
      );
    }
    if (num < 10000000) {
      const lakhs = Math.floor(num / 100000);
      const rest = num % 100000;
      const lakhText = lakhs === 1 ? " lakh" : " lakhs";
      return (
        convertIntegerPart(lakhs) +
        lakhText +
        (rest > 0 ? " " + convertIntegerPart(rest) : "")
      );
    }
    if (num < 100000000) {
      const crores = Math.floor(num / 10000000);
      const rest = num % 10000000;
      const croreText = crores === 1 ? " crore" : " crores";
      return (
        convertIntegerPart(crores) +
        croreText +
        (rest > 0 ? " " + convertIntegerPart(rest) : "")
      );
    }

    // Handle larger numbers (millions, billions, etc.) if needed
    return "Number too large";
  };

  const convertDecimalPart = (decimalPart: number): string => {
    return convertIntegerPart(decimalPart);
  };

  // Handle edge case where num might be undefined or null
  if (num === null || num === undefined) {
    return "Invalid number";
  }

  const parts = num.toString().split(".");

  // Integer part conversion
  const integerPart = parseInt(parts[0]);
  let result = convertIntegerPart(integerPart);

  // Default suffix for different currencies
  let decimalSuffix = "paisa"; // Default for INR

  // Set appropriate decimal suffix based on currency
  if (currency === "USD") {
    decimalSuffix = "cents";
  } else if (currency === "AED") {
    decimalSuffix = "fils";
  }

  // Decimal part conversion (only if there's a decimal)
  if (parts.length > 1) {
    const decimalPart = parseInt(parts[1]); // Use the decimal part as an integer
    result += " and " + convertDecimalPart(decimalPart) + " " + decimalSuffix;
  }

  return result + " only"; // Append 'only' to indicate completion of the amount in words
}

export const getFormattedDateWithSuffix = (date: any): string => {
  const d = dayjs.utc(date);
  const day = d.date();
  let suffix = "th";

  if (day % 10 === 1 && day !== 11) suffix = "st";
  else if (day % 10 === 2 && day !== 12) suffix = "nd";
  else if (day % 10 === 3 && day !== 13) suffix = "rd";

  const dayWithSuffix = day + suffix;
  return (
    dayjs(date).format("dddd, ") +
    dayWithSuffix +
    dayjs(date).format(" MMM YYYY")
  );
};

// export const uiEncryption = (originalText: string, secretKey: string) => {
//   if (originalText && secretKey) {
//     // Encrypt the text
//     const encrypted = CryptoJS.AES.encrypt(originalText, secretKey).toString();

//     // Take first 10 characters or pad with 'x' if shorter
//     const shortEncrypted = (encrypted.slice(0, 10) + "xxxxxxxxxx").slice(0, 10);
//     return shortEncrypted;
//   }
// };

// export const uiDecryption = (encryptedText: string, secretKey: string) => {
//   if(!encryptedText || !secretKey){
//     return false;
//   }
//   try {
//     // Attempt to decrypt
//     const decrypted = CryptoJS.AES.decrypt(encryptedText, secretKey).toString(
//       CryptoJS.enc.Utf8
//     );
//     return decrypted;
//   } catch (error) {
//     alert("Decryption failed. Check your secret key.");
//   }
// };

export const addProductQuote = (
  product: "hotel" | "transfer" | "activity",
  item: any,
  setAddedQuoteCount?: (value: any) => void,
) => {
  if (product == "hotel") {
    const hotelQuotes = DOMPurify.sanitize(
      localStorage.getItem("hotelQuotes") as string,
    );
    const LocalQuoteRooms = hotelQuotes ? JSON.parse(hotelQuotes) : [];

    if (
      LocalQuoteRooms &&
      Array.isArray(LocalQuoteRooms) &&
      LocalQuoteRooms?.length > 0
    ) {
      // Check if the item already exists based on rate_key
      const exists = LocalQuoteRooms.some(
        (existingItem: any) => existingItem?.rate_key === item?.rate_key,
      );

      if (!exists) {
        // If the item does not exist, add it to LocalQuoteRooms
        LocalQuoteRooms.push(item);
        localStorage.setItem("hotelQuotes", JSON.stringify(LocalQuoteRooms));
        setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);

        // customNotify({
        //   message: "Quote added successfully",
        //   description: "",
        //   type: "success",
        // });
        UIMessage({
          messageText: "Quote added successfully",
          btnText: "Okay",
          onClose: () => { },
          closeIcon: true,
        });
      } else {
        // Remove the item with the same rate_key
        const updatedQuoteRooms = LocalQuoteRooms.filter(
          (existingItem: any) => existingItem?.rate_key !== item?.rate_key,
        );

        // Update LocalQuoteRooms with the filtered array
        LocalQuoteRooms.length = 0; // Clear the existing array
        LocalQuoteRooms.push(...updatedQuoteRooms); // Push the filtered items back into LocalQuoteRooms
        localStorage.setItem("hotelQuotes", JSON.stringify(LocalQuoteRooms));
        setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);
      }
    } else {
      LocalQuoteRooms.push(item);
      localStorage.setItem("hotelQuotes", JSON.stringify(LocalQuoteRooms));
      setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);

      // customNotify({
      //   message: "Quote added successfully",
      //   description: "",
      //   type: "success",
      // });
      UIMessage({
        messageText: "Quote added successfully",
        btnText: "Okay",
        onClose: () => { },
        closeIcon: true,
      });
    }
  }

  if (product == "transfer") {
    const transferQuotes = DOMPurify.sanitize(
      localStorage.getItem("transferQuotes") as string,
    );
    const LocalQuoteTransfers = transferQuotes
      ? JSON.parse(transferQuotes)
      : [];

    if (
      LocalQuoteTransfers &&
      Array.isArray(LocalQuoteTransfers) &&
      LocalQuoteTransfers?.length > 0
    ) {
      // Check if the item already exists based on ratekey
      const exists = LocalQuoteTransfers.some(
        (existingItem: any) => existingItem?.ratekey === item?.ratekey,
      );

      if (!exists) {
        // If the item does not exist, add it to LocalQuoteTransfers
        LocalQuoteTransfers.push(item);
        localStorage.setItem(
          "transferQuotes",
          JSON.stringify(LocalQuoteTransfers),
        );
        setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);

        // customNotify({
        //   message: "Quote added successfully",
        //   description: "",
        //   type: "success",
        // });
        UIMessage({
          messageText: "Quote added successfully",
          btnText: "Okay",
          onClose: () => { },
          closeIcon: true,
        });
      } else {
        // Remove the item with the same ratekey
        const updatedQuoteRooms = LocalQuoteTransfers.filter(
          (existingItem: any) => existingItem?.ratekey !== item?.ratekey,
        );

        // Update LocalQuoteTransfers with the filtered array
        LocalQuoteTransfers.length = 0; // Clear the existing array
        LocalQuoteTransfers.push(...updatedQuoteRooms); // Push the filtered items back into LocalQuoteTransfers
        localStorage.setItem(
          "transferQuotes",
          JSON.stringify(LocalQuoteTransfers),
        );
        setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);
      }
    } else {
      LocalQuoteTransfers.push(item);
      localStorage.setItem(
        "transferQuotes",
        JSON.stringify(LocalQuoteTransfers),
      );
      setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);

      // customNotify({
      //   message: "Quote added successfully",
      //   description: "",
      //   type: "success",
      // });
      UIMessage({
        messageText: "Quote added successfully",
        btnText: "Okay",
        onClose: () => { },
        closeIcon: true,
      });
    }
  }

  if (product == "activity") {
    const activityQuotes = DOMPurify.sanitize(
      localStorage.getItem("activityQuotes") as string,
    );
    const ActivityQuotes = activityQuotes ? JSON.parse(activityQuotes) : [];

    if (
      ActivityQuotes &&
      Array.isArray(ActivityQuotes) &&
      ActivityQuotes?.length > 0
    ) {
      // Check if the item already exists based on id, code
      const exists = ActivityQuotes.some(
        (existingItem: any) =>
          existingItem?.id + existingItem?.code === item?.id + item?.code,
      );

      if (!exists) {
        // If the item does not exist, add it to ActivityQuotes
        ActivityQuotes.push(item);
        localStorage.setItem("activityQuotes", JSON.stringify(ActivityQuotes));
        setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);

        // customNotify({
        //   message: "Quote added successfully",
        //   description: "",
        //   type: "success",
        // });
        UIMessage({
          messageText: "Quote added successfully",
          btnText: "Okay",
          onClose: () => { },
          closeIcon: true,
        });
      } else {
        // Remove the item with the same id, code
        const updatedQuoteRooms = ActivityQuotes.filter(
          (existingItem: any) =>
            existingItem?.id + existingItem?.code !== item?.id + item?.code,
        );

        // Update ActivityQuotes with the filtered array
        ActivityQuotes.length = 0; // Clear the existing array
        ActivityQuotes.push(...updatedQuoteRooms); // Push the filtered items back into ActivityQuotes
        localStorage.setItem("activityQuotes", JSON.stringify(ActivityQuotes));
        setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);
      }
    } else {
      ActivityQuotes.push(item);
      localStorage.setItem("activityQuotes", JSON.stringify(ActivityQuotes));
      setAddedQuoteCount && setAddedQuoteCount(getAllAddedQuotes()?.length);

      // customNotify({
      //   message: "Quote added successfully",
      //   description: "",
      //   type: "success",
      // });
      UIMessage({
        messageText: "Quote added successfully",
        btnText: "Okay",
        onClose: () => { },
        closeIcon: true,
      });
    }
  }
};

export const getActivityAddedQuotes = () => {
  const activityQuotes = DOMPurify.sanitize(
    localStorage.getItem("activityQuotes") as string,
  );
  const localQuoteActivities = activityQuotes ? JSON.parse(activityQuotes) : [];
  return localQuoteActivities;
};

export const getHotelAddedQuotes = () => {
  const hotelQuotes = DOMPurify.sanitize(
    localStorage.getItem("hotelQuotes") as string,
  );
  const localQuotes = hotelQuotes ? JSON.parse(hotelQuotes) : [];
  return localQuotes;
};

export const getTransferAddedQuotes = () => {
  const transferQuotes = DOMPurify.sanitize(
    localStorage.getItem("transferQuotes") as string,
  );
  const localQuotes = transferQuotes ? JSON.parse(transferQuotes) : [];
  return localQuotes;
};

export const clearAllQuotes = () => {
  localStorage.setItem("activityQuotes", JSON.stringify([]));
  localStorage.setItem("hotelQuotes", JSON.stringify([]));
  localStorage.setItem("transferQuotes", JSON.stringify([]));
};

export const getAllAddedQuotes = () => {
  const activityQuotes = DOMPurify.sanitize(
    localStorage.getItem("activityQuotes") as string,
  );
  const localQuoteActivities = activityQuotes ? JSON.parse(activityQuotes) : [];

  const hotelQuotes = DOMPurify.sanitize(
    localStorage.getItem("hotelQuotes") as string,
  );
  const localHotelQuotes = hotelQuotes ? JSON.parse(hotelQuotes) : [];

  const transferQuotes = DOMPurify.sanitize(
    localStorage.getItem("transferQuotes") as string,
  );
  const localTransferQuotes = transferQuotes ? JSON.parse(transferQuotes) : [];

  return [...localQuoteActivities, ...localHotelQuotes, ...localTransferQuotes];
};

export const getCompareRooms = () => {
  const hotelCompare = DOMPurify.sanitize(
    localStorage.getItem("hotelCompare") as string,
  );
  const localHotelCompare = hotelCompare ? JSON.parse(hotelCompare) : [];
  return localHotelCompare;
};

export const decodeBookingDraftResponse = ({ response }: { response: any }) => {
  try {
    if (response?.data?.bookingDraftByTwbid?.responseData) {
      const bookingDraftresponse = JSON.parse(JSON.stringify(response));
      const decryptedData = decryptAPIData(
        bookingDraftresponse?.data?.bookingDraftByTwbid?.responseData,
      );

      const parsedData = decryptedData ? JSON.parse(decryptedData) : {};
      bookingDraftresponse.data.bookingDraftByTwbid.responseData = parsedData;

      return bookingDraftresponse;
    } else {
      return response;
    }
  } catch (error) {
    console.error(error);
    return response;
  }
};

export const convertToCurrency = (value: any) => {
  if (value === null || value === undefined) return value;
  const currency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return currency.format(value).replace("$", "").replace(".00", "");
};

export const toTitleCase = (str?: string): string | undefined =>
  typeof str === "string" && str
    ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
    : str;

export const removeTrailingUnderscore = (str?: string): string | undefined =>
  str?.endsWith("_") ? str.slice(0, -1) : str;

// Replaces tabs (and any other run of whitespace) with a single space, and trims
// the leading/trailing edges (e.g. "  a\tb\tc  " -> "a b c").
export const cleanText = (value?: string | null): string =>
  (value || "").trim().replace(/\s+/g, " ");

// Replaces HTML/XML tags with a space (so words on either side don't run together),
// leaving the text content untouched
// (e.g. "Hello<br>World" -> "Hello World", not "HelloWorld").
export const stripHtmlTags = (value?: string | null): string =>
  (value || "").replace(/<[^>]*>/g, " ");

// Recursively trims leading/trailing whitespace and collapses repeated inner whitespace
// (e.g. "John   Doe" -> "John Doe") from every string value in an object/array.
export const trimDeep = <T,>(value: T): T => {
  if (typeof value === "string") {
    return value.trim().replace(/\s+/g, " ") as unknown as T;
  }
  if (Array.isArray(value)) {
    return value.map((item) => trimDeep(item)) as unknown as T;
  }
  if (
    value &&
    typeof value === "object" &&
    (Object.getPrototypeOf(value) === Object.prototype ||
      Object.getPrototypeOf(value) === null)
  ) {
    // Only recurse into plain objects. Class instances (Date, dayjs, etc.)
    // are returned as-is: walking them with for-in strips their prototype
    // methods and corrupts internal state (e.g. Date has no enumerable own
    // properties, so it would be rebuilt as `{}`).
    const result: Record<string, unknown> = {};
    for (const key of Object.keys(value as Record<string, unknown>)) {
      result[key] = trimDeep((value as Record<string, unknown>)[key]);
    }
    return result as T;
  }
  return value;
};

export function customDebounce(func: (...args: any[]) => void, delay: number) {
  let timeout: ReturnType<typeof setTimeout>;
  return function (this: unknown, ...args: any[]) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export const calculateAge = (dob: any) => {
  const birthDate = dayjs(dob, "DD/MM/YYYY");
  const today = dayjs();
  return today.diff(birthDate, "year");
};

export const convertUTCtoIST = (
  date: any,
  format: string = "DD-MMM-YYYY HH:mm:ss",
) => {
  if (!date) return "-";

  return dayjs.utc(date).tz("Asia/Kolkata").format(format);
};

export const convertISTtoUST = (date: any) => {
  const istDate = dayjs.tz(date, "Asia/Kolkata");
  const utcDate = istDate.utc();
  return utcDate;
};

export const getPassportNumbers = (paxData: any) => {
  const passportNumbers = paxData?.items?.flatMap((item: any) => {
    const adult =
      item?.adults?.map((adult: any) => adult["passport-textField"]) || [];
    const senior =
      item?.seniors?.map((senior: any) => senior["passport-textField"]) || [];
    const child =
      item?.children?.map((child: any) => child["passport-textField"]) || [];
    const infant =
      item?.infants?.map((infant: any) => infant["passport-textField"]) || [];
    const youth =
      item?.youths?.map((youth: any) => youth["passport-textField"]) || [];
    return [...adult, ...senior, ...child, ...infant, ...youth];
  });
  return passportNumbers;
};

export const getOrdinalSuffixOnly = (n: any) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
};

export const formatDateWithSuperscript = (utcString: string) => {
  const date = dayjs(utcString);
  const d = date.date();
  const s: any = { 1: "ˢᵗ", 2: "ⁿᵈ", 3: "ʳᵈ" };
  const v = d % 100;
  const suffix = s[(v - 20) % 10] || s[v] || "ᵗʰ";
  return `${d}${suffix} ${date.format("MMM YYYY")}`;
};

export const formatNumber = (value: number) => {
  if (isNaN(value)) return "0.00";
  return Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export interface FormatAmountOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export const formatAmount = (
  value: number | string | null | undefined,
  options?: FormatAmountOptions,
) => {
  if (value === null || value === undefined || value === "") return "N/A";

  const normalized =
    typeof value === "string" ? value.replace(/,/g, "").trim() : value;
  const num = Number(normalized);
  if (!Number.isFinite(num)) return "N/A";

  const maxFrac = options?.maximumFractionDigits ?? 20;
  const intlOpts: Intl.NumberFormatOptions = {
    maximumFractionDigits: maxFrac,
  };
  if (options?.minimumFractionDigits !== undefined) {
    intlOpts.minimumFractionDigits = options.minimumFractionDigits;
  }
  return new Intl.NumberFormat("en-US", intlOpts).format(num);
};

export const escapeRegex = (string: string) =>
  // No newline at end of file
  string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// utils/openPdfInNewTab.ts

/**
 * Open a Base64 PDF in a new browser tab.
 * @param base64 - The Base64 string of the PDF
 */
// utils/openAndDownloadPdf.ts

/**
 * Opens a Base64 PDF in a new tab and triggers automatic download
 * @param base64 - Base64 string of the PDF
 * @param filename - Name for the downloaded file (default: "file.pdf")
 */
export const openAndDownloadPdf = (
  base64: string,
  filename = "document.pdf",
) => {
  // 1. Convert Base64 to Blob (Using a more performant loop)
  const byteCharacters = atob(base64);
  const byteArray = new Uint8Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }
  const blob = new Blob([byteArray], { type: "application/pdf" });

  // 2. Create a temporary URL
  const pdfUrl = URL.createObjectURL(blob);

  // 3. Create a hidden anchor element
  const link = document.createElement("a");
  link.href = pdfUrl;
  link.download = filename;

  // 4. Append, Click, and Cleanup
  document.body.appendChild(link);
  link.click();

  // Clean up the DOM and memory
  document.body.removeChild(link);
  URL.revokeObjectURL(pdfUrl);
};
// utils/printPdf.ts

/**
 * Opens a Base64 PDF in a new tab and triggers the print dialog
 * @param base64 - Base64 string of the PDF
 */
// utils/printPdfDirect.ts

/**
 * Prints a Base64 PDF directly without opening a new tab
 * @param base64 - Base64 string of the PDF
 */
export const printPdf = (base64: string) => {
  // 1. Clean up any previous print frames to avoid DOM clutter
  const existingFrame = document.getElementById("pdf-print-frame");
  if (existingFrame) {
    document.body.removeChild(existingFrame);
  }

  // 2. Convert Base64 to Blob
  const byteCharacters = atob(base64);
  const byteArray = new Uint8Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const pdfUrl = URL.createObjectURL(blob);

  // 3. Create the hidden iframe
  const iframe = document.createElement("iframe");
  iframe.id = "pdf-print-frame";
  iframe.style.visibility = "hidden";
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.src = pdfUrl;

  document.body.appendChild(iframe);

  // 4. Trigger Print
  iframe.onload = () => {
    // A tiny delay ensures the browser's PDF viewer is ready
    setTimeout(() => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();

      // Cleanup: Memory management
      URL.revokeObjectURL(pdfUrl);
    }, 250);
  };
};

export const useScreenWidth = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return screenWidth;
};

export const formatChartValue = (value: number, currency: string) => {
  if (!value && value !== 0) return "";

  if (currency === "INR") {
    if (value >= 10000000) return `${(value / 10000000).toFixed(1)}Cr`;
    if (value >= 100000) return `${(value / 100000).toFixed(1)}L`;
    if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
    return value.toString();
  }

  // USD, EUR, GBP, AED, etc.
  if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return value.toString();
};